import AbsModule from '../common/AbsModule';
import { getIsJSON } from '../common/util';
import { toggleDisplay } from '../common/domUtil';
import { SWIPER_MODULE, setSwiper } from '../components/Swiper';
import { NSHOP_COUPON_DOMAIN, PLATFORM, SHORTCUT, getShortcutDefaultList } from '../common/const';

class Shortcut extends AbsModule {
    constructor(_config) {
        super(_config.shortCut, _config.shortCut.isShow);

        this.platform = this.com?.platform;

        this.dataBindList = [];
        this.showArrowBtnLength = 5; // shortcut 5개부터 .ncc-shortcut-btn 버튼 노출하도록
        this.shortcutData = this.setShortcutData();
        this.isMobile = this.com?.isMobile;
    }

    startSetting() {
        if (this.isMobile) {
            const linkMypage = document.querySelector('#nc-cnb .ncc-shortcut-item__link__mypage');

            linkMypage?.addEventListener('click', e => {
                let url = e.currentTarget?.getAttribute('href');

                url && window.open(url, 'myPage');
                return false;
            });
        }

        // function 타입 숏컷
        const { purpleCheck, env } = this.com || {};
        const { isPurpleApp } = purpleCheck;
        const shortcutFuncItem = document.querySelectorAll('.ncc-shortcut-item__link[data-func-name]');
        if(shortcutFuncItem?.length > 0) {
            shortcutFuncItem.forEach(item => {
                item?.addEventListener('click', (e) => {
                    const target = e.currentTarget;
                    const funcName = target?.dataset?.funcName;
                    let funcParams = target?.dataset?.funcParams;

                    if(getIsJSON(funcParams)) {
                        funcParams = JSON.parse(funcParams);
                    }

                    let thisValue = target;
                    const func = funcName.split('.').reduce((acc, curVal) => {
                        const obj = acc[curVal];
                        if (typeof obj === 'object') {
                            thisValue = obj;
                        }
                        return obj;
                    }, window);

                    e.preventDefault();

                    if(isPurpleApp && funcParams?.popup_service === 'nshop_coupon') { // 퍼플 모바일앱(인앱)일 때, 내부 이동
                        location.href = NSHOP_COUPON_DOMAIN[env];
                    } else {
                        func.call(thisValue, funcParams);
                    }
                });
            });
        }

        this.setShortcutSwiper(); // shortcut swiper 활성화
    }

    makeMarkup() {
        const data = this.shortcutData;
        const l10nD = this.com.l10nData.Shortcut;
        const listLng = data?.length || 0;

        if(!Array.isArray(data) || data?.length === 0) {
            return '';
        }

        return `
        <nav class="ncc-shortcut">
            <strong class="blind">${l10nD.GotoService}</strong>
            <ul id="ncc-shortcut-list" class="ncc-shortcut-list ncc-shortcut-list-length${listLng}">
                ${data?.map(v => {
                    const key = v[0];
                    const value = v[1];

                    if(!this.isMobile && key === SHORTCUT.GIFT.key) {
                        return '';
                    }

                    return [SHORTCUT.COUPON_GAME.key, SHORTCUT.NPOINT_GAME.key]?.includes(key) ? this.makeItem(value, 'game') : this.makeItem(value);
                })?.join('')}
            </ul>
            <button type="button" class="ncc-shortcut-btn ncc-shortcut-btn--prev" data-direction="prev" style="display:none;">&lt;</button>
            <button type="button" class="ncc-shortcut-btn ncc-shortcut-btn--next" data-direction="next" style="display:none;">&gt;</button>
            <div class="swiper-scrollbar" style="display:none;"></div>
        </nav>`;
    }

    // shortcut 데이터 가공
    setShortcutData() {
        const { isNct, isNcj, rcDash, env } = this.com || {};

        // 1) cnbConfig.shortCut?.key?: true 포함
        // 2) cnbConfig.shortCut?.key?.isShow: true 포함
        // 3) cnbConfig.shortCut?.isShow 제거
        // 4) cnbConfig.shortCut?.useCustom 제거 
        // 5) [NCT/NCJ일 때] cnbConfig.shortCut?.charHome 제거 
        // 6) [퍼플 모바일일때]cnbConfig.shortCut?.ncoin 제거 [PSD-14427]


        const { purpleCheck } = this.com || {};
        const { isPurpleApp } = purpleCheck;

        const setConfigData = (obj = {}) => {
            delete obj?.isShow;
            delete obj?.useCustomSort;

            for(let key in obj) {
                if(!obj[key] || (typeof obj[key] === 'object' && !obj[key]?.isShow) || ((isNct || isNcj) && key === SHORTCUT.CHAR_HOME.key) || (isPurpleApp && key === SHORTCUT.NCOIN.key)) {
                    delete obj[key];
                }
            }

            return obj;
        };
        
        
        const l10nD = this.com.l10nData.Shortcut;
        const useCustomSort = this.moduleData?.useCustomSort || false; // shortcut 정렬 순서(default: false(SHORTCUT에 정의된 순서) / true: cnbConfig.shortCut에서 정의한 순서)
        const defaultData = getShortcutDefaultList(rcDash, env);
        const configData = setConfigData({...this.moduleData}) || {};
        const nshopData = window.userData.nshop || window.userData.nShop || {};
        const defaultDataKeys = Object.keys(defaultData);
        const configDataKeys = Object.keys(configData);
        const sortArr = useCustomSort ? configDataKeys : defaultDataKeys?.filter(v => configDataKeys?.includes(v));
        let newData = [];

        sortArr?.forEach(key => {
            const defaultValue = defaultData[key] || {};
            const configValue = configData[key] || {};
            const { l10nKey } = defaultValue;
            let value = typeof configValue === 'object' ? {...defaultValue, ...configValue} : typeof configValue === 'boolean' ? {...defaultValue, isShow: configValue} : {...defaultValue};
            
            value['title'] = value['title'] ? value['title'] : l10nKey ? l10nD[l10nKey] : '';

            if([SHORTCUT.NCOIN.key, SHORTCUT.ENTER_COUPON.key].includes(key)) {
                const isEnterCoupon = key === SHORTCUT.ENTER_COUPON.key;
                const { iconClass, title } = this.getShortCutItem({
                    name: value['iconClass'], 
                    l10n: value['title'], 
                    count: isEnterCoupon ? nshopData.coupon : nshopData.nCoin || nshopData.ncoin, 
                    maxCount: isEnterCoupon ? 99 : 999999, 
                    prefix: isEnterCoupon ? l10nD.CouponLang : '{}'
                }) || {};
                
                value['title'] = title;
                value['iconClass'] = iconClass;
            }

            newData.push([key, value]);
        });

        return newData;
    }

    getShortCutItem({ name, l10n, count, maxCount, prefix }) {
        let iconClass = name,
            title = l10n;
        if (count) {
            title = this.getShortCutNumber(count, maxCount);
            if (title === '' || parseInt(title, 10) === 0) {
                title = l10n;
            } else {
                iconClass += ' is-number';
                title = prefix.replace('{}', title);
            }
        }

        return {
            iconClass,
            title
        };
    }

    getShortCutNumber(num, maxCount) {
        if(typeof num === 'string') {
            num = parseInt(num, 10);
        }

        if (typeof num === 'number' && num > 0) {
            num = num
                .toString()
                .replace(/^\s\s*/, '')
                .replace(/\s\s*$/, '');
            let chkNum = parseInt(num, 10),
                isFull = '';
            if (chkNum > maxCount) {
                num = maxCount.toString();
                isFull = '+';
            }
            return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + isFull;
        } else {
            return '';
        }
    }

    makeItem(value, suffix = '') {
        if (!value || !value?.isShow) {
            return '';
        }

        let { iconType, type, url, title, iconClass, popupName, popOption, name, params } = value || {};
        let linkType = iconType || type;
        let aTag = '';

        switch (linkType) {
            case 'popup':
                aTag = `<a href="javascript:void(0)" onclick="window.open('${url}', '${this.com?.setLinkTarget(popupName)}', '${popOption}').focus(); return false;" class="ncc-shortcut-item__link">`;
                break;
            case 'function':
                aTag = `<a href="#" class="ncc-shortcut-item__link" data-func-name="${name}" data-func-params='${JSON.stringify(params)}' >`;
                break;
            default:
                aTag = `<a href="${url}" target="${linkType === 'external'? '_blank': '_self'}" class="ncc-shortcut-item__link">`;
        }

        return `
        <li class="ncc-shortcut-item">
            ${aTag}
                <i class="icon-shortcut icon-shortcut--${iconClass}"></i>
                <span class="desc" id="ncc-shortcut-databind-${iconClass}${suffix ? `-${suffix}` : '' }">${title}</span>
            </a>
        </li>`;
    }

    // shortcut.length >= 5 인지 확인 후, swiper 활성화
    setShortcutSwiper() {
        const shortcut = document.querySelector('#nc-cnb .ncc-shortcut');
        const shortcutList = shortcut?.querySelector('.ncc-shortcut-list');
        const shortcutItem = shortcutList?.querySelectorAll('.ncc-shortcut-item');
        const shortcutBtn = shortcut?.querySelectorAll('.ncc-shortcut-btn');
        const itemLength = shortcutItem?.length || 0;
        const isActiveSwiper = itemLength >= this.showArrowBtnLength;

        if(!isActiveSwiper) {
            return;
        }

        shortcut?.classList?.add('swiper');
        shortcutList?.classList?.add('swiper-wrapper');
        shortcutItem?.forEach(v => v?.classList?.add('swiper-slide'));

        let option = {
            loop: false,
            slidesPerView: 'auto',
            resizeObserver: true
        };

        if(this.isMobile) {
            toggleDisplay(document.querySelector('.swiper-scrollbar'), true);
            option = {
                ...option,
                modules: [SWIPER_MODULE.SCROLLBAR],
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false
                }
            }
        } else {
            if(shortcutBtn?.length > 0) {
                shortcutBtn?.forEach(btn => {
                    const direction = btn?.dataset?.direction;
                    btn?.classList?.add(direction === 'prev' ? 'swiper-button-prev' : direction === 'next' ? 'swiper-button-next' : '')
                    toggleDisplay(btn, true);
                });
            }

            option = {
                ...option,
                modules: [SWIPER_MODULE.NAVIGATION],
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }

        this.swiper = setSwiper('.ncc-shortcut.swiper', option);
    }
}

export default Shortcut;